import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { DeleteEntityPrompt } from "../../Partials/Dialog/DeleteEntityPrompt";
import { TableComponent } from "../../Partials/Table/TableComponent";
// import { SubscriptionIcon } from "../../Partials/Subscription/SubscriptionIcon";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CircularProgress from '@material-ui/core/CircularProgress';
import TextField from "../../Partials/Material/TextField";
import Card from '@material-ui/core/Card';
import { TabsComponent } from "./TabsComponent";

class Persons extends Component {
  public selectedPerson: PersonInterface;
  protected textFieldRef;

  public state = {
    anchorEl: null,
    isDeletePromptOpen: false,
    filterValue: '',
    searchInProgress: false,
    results: this.props.app.companies
  };

  constructor(public props) {
    super(props);
    this.textFieldRef = React.createRef();
  }

  public componentWillMount() {
    this.props.dispatch({
      type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
    });
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.location.pathname === "/app/companies"){
      this.setState({
        companiesSeparatePage: true
      });
    }
  }


  protected openMenu = (event: any, person: PersonInterface): void => {
    this.selectedPerson = person;

    this.setState({
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  protected openPrompt = (): void => {
    this.setState({
      isDeletePromptOpen: true,
      anchorEl: null
    });
  }

  public closePrompt = (): void => {
    this.setState({
      isDeletePromptOpen: false
    });
  }

  public delete = (person: PersonInterface): void => {
    return this.props.dispatch({
      type: Constants.GLOBAL_PERSON_DELETE_START,
      payload: {
        person: person
      },
      onSuccess: this.closePrompt
    });
  }

  public setFilterValue = (event: any): void => {
    const filterValue: string = event.target.value;

    this.setState({
      filterValue: filterValue
    });
  }

  protected getPersons = (): any => {
    return this.props.app.persons
      .filter((person: PersonInterface) => !!person &&
                                           !person.removed &&
                                           !person.createdBySystem &&
                                           (!person.role ||
                                           (!!person.role && person.role.getRoleId() !== 1 && person.role.getRoleId() !== 6)))
                                           .filter((person: PersonInterface) => !!person && (this.state.filterValue ? person.displayName.toLowerCase().includes(this.state.filterValue.toLowerCase()) : true))
                                           .sort((person1: PersonInterface, person2: PersonInterface) => {
        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` > `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return 1;
        }

        if (`${person1.firstName.toLowerCase()} ${person1.lastName.toLowerCase()}` < `${person2.firstName.toLowerCase()} ${person2.lastName.toLowerCase()}`) {
          return -1;
        }

        return  0;
      })
      .map((person: PersonInterface, key: number) => {
        return (
          <TableRow
            hover
            key={key}
            className={`clickable-entity`}
            onClick={() => {
                this.redirect(`/app/person/update/${person.id}`);
            }}
          >
            {/* <TableCell>
              <SubscriptionIcon entity={company} {...this.props} />
            </TableCell> */}
            <TableCell style={{width: "50px"}}>
              <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                {person.renderAvatar()}
              </div>
            </TableCell>
            <TableCell>{person.displayName}</TableCell>
            <TableCell>{person.email}</TableCell>
            <TableCell>{person?.companies?.map(company => company?.displayName)?.join(", ")}</TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, person)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.selectedPerson && this.selectedPerson.id === person.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => {
                      this.redirect(`/app/person/update/${this.selectedPerson.id}`)
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    className="delete-action"
                    onClick={this.openPrompt}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-finance has-general-page-header full-width with-tabs bottom-whitespace ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <div style={{padding: "0 40px", display: "flex", justifyContent: "space-between"}}>
              <h1 style={{padding: "24px 0"}}>{this.trans("title-contacts")}</h1>
              <div className="button-container">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.redirect("/app/person/create")}
                >
                  {this.trans("button-add-person")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.redirect("/app/company/create")}
                >
                  {this.trans("button-new-company")}
                </Button>
              </div>
            </div>
            <TabsComponent
              activeTab={0}
              {...this.props}
            />
          </div>
          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  // alignItems: "baseline"
                }}
              >
                <h3 className="card-title" style={{ flexDirection: "column", display: "flex" }}>
                  {this.trans("title-contacts")}
                </h3>
              </div>

              <div>
                <div
                  className="list-filters-wrapper"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center"
                  }}
                >
                  <div className="table-filterer">
                    <TextField
                      autoComplete="off"
                      type="text"
                      style={{ color: "rgb(0, 188, 212)" }}
                      label={this.trans("label-search")}
                      value={this.state.filterValue}
                      onChange={this.setFilterValue}
                      variant="standard"
                      error={false}
                      inputRef={this.textFieldRef}
                    />
                    {
                      this.state.filterValue !== "" &&
                      <div className="icon icon-ic-close clear-button clear-button-search" onClick={() => this.setState({ filterValue: "" })}></div>
                    }
                    {
                      this.state.searchInProgress &&
                      <div className="search-loader">
                        <CircularProgress size={20} />
                      </div>
                    }
                  </div>
                </div>
                <TableComponent
              {...this.props}
              className={"persons-listing-table listing-table"}
              paginator={{
                name: "Persons",
                path: this.props.app.paginator
              }}
              dispatch={this.props.dispatch}
              entities={this.props.app.persons}
              isFetched={this.props.app.loadedEntities.includes(Constants.GLOBAL_PERSON_LIST_SUCCESS)}
              rows={this.getPersons()}
              isChildListingTable={false}
              subtitle={this.trans("page/persons-info/nopersonsfound")}
              ignoreFirstCellClick={true}
              headers={["", this.trans("title-person"), this.trans("title-email"), this.trans("title-company"), ""]}
            />
              </div>
            </Card>
          </div>
        </div>

        <DeleteEntityPrompt
          {...this.props}
          entityName={'contact-person-remove-dialog'}
          isOpen={this.state.isDeletePromptOpen}
          onCancel={this.closePrompt}
          onDelete={() => this.delete(this.selectedPerson)}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.persons,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Persons
);
